import type { FC } from 'react';
import React, { cloneElement } from 'react';

import { useRouterContext } from '../router/context';

import type { IProps } from './models';

/** Компонент, который показывает значение текущего роута или роутера */
export const Current: FC<IProps> = ({
    children,
    propsMap = { routeProp: 'route', routerProp: 'router' },
    ...transitProps
}) => {
    const { name, route } = useRouterContext();

    if (!children) return <>{`${name}/${route}`}</>;

    return cloneElement(children, {
        ...transitProps,
        ...(propsMap.routeProp && { [propsMap.routeProp]: route }),
        ...(propsMap.routerProp && { [propsMap.routerProp]: name }),
    });
};
